import { render, staticRenderFns } from "./indicators_table.vue?vue&type=template&id=452b5ebd&scoped=true"
import script from "./indicators_table.vue?vue&type=script&lang=js"
export * from "./indicators_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b5ebd",
  null
  
)

export default component.exports